import React, { useCallback, useEffect, useMemo, useState } from 'react'
import ElementRenderer from './ElementRenderer';
import { useSearchTerm } from '../SearchContext';
import { IconButton } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import EditIcon from '@mui/icons-material/Edit';
import { useDispatch } from 'react-redux';
import { useYObject } from '../../hooks/documentHooks';
import BaseElement from './BaseElement';
import { getPropertyName } from '../../helpers/utils';

const ListMutator = ({ definition, value, parent, itemKey, path, buttons, parentDefinition, dataTranslation, dataTranslationMap }) => {
  const newData = useYObject(value)
  const [open, setOpen] = useState(!parent)
  const { foundItems } = useSearchTerm()

  const title = useMemo(() => getPropertyName(definition?.title, itemKey), [definition, itemKey])
  const dispatch = useDispatch()

  const toggleOpen = useCallback(() => {
    setOpen(!open)
  }, [open])

  const handleCreate = useCallback((event) => {
    if (definition?.create?.templates) {
      dispatch({
        type: 'insert-template-modal',
        templates: definition.create.templates.sort((curr, next) => curr.title > next.title ? 1 : curr.title === next.title ? 0 : -1),
        object: value,
        path
      })
    }
    event.stopPropagation()
  }, [dispatch, definition, value, path])

  const handleEdit = useCallback((event) => {
    dispatch({
      type: 'edit-json',
      data: value
    })
    setOpen(false)
    event.stopPropagation()
  }, [value, dispatch])

  useEffect(() => {
    if (foundItems && Object.keys(foundItems).length > 0) {
      const found = Object.keys(foundItems).find(item => item.startsWith(path))
      setOpen(!!found || !parent)
    }
  }, [foundItems, path, parent])

  return (
    <BaseElement error={!definition}>
      <header-area onClick={toggleOpen}>
        <span>{title} <small>{parentDefinition?.children_title_key && `- ${newData[parentDefinition?.children_title_key]}`}</small></span>
        <div>
          {buttons}
          {definition && definition.create && !dataTranslation && <IconButton size="small" onClick={handleCreate}><AddCircleOutlineIcon /></IconButton>}
          {!dataTranslation && <IconButton size="small" onClick={handleEdit}><EditIcon /></IconButton>}
        </div>
      </header-area>
      <section-content>
        {open && Object.keys(newData).map(key =>
          <ElementRenderer 
            key={key}
            parent={value} 
            itemKey={key} 
            value={newData[key]} 
            path={path ? `${path}[${key}]` : key} 
            definition={definition?.items} 
            parentDefinition={definition}
            dataTranslation={dataTranslation}
            dataTranslationMap={dataTranslationMap}
          />
        )}
      </section-content>
    </BaseElement>    
  )
}

export default ListMutator